export var StickTo;

(function (StickTo) {
  StickTo["Left"] = "left";
  StickTo["Right"] = "right";
})(StickTo || (StickTo = {}));

export var RowActionType;

(function (RowActionType) {
  RowActionType["Inline"] = "Inline";
  RowActionType["Dropdown"] = "Dropdown";
})(RowActionType || (RowActionType = {}));

export var ColumnTextAlign;

(function (ColumnTextAlign) {
  ColumnTextAlign["Left"] = "left";
  ColumnTextAlign["Center"] = "center";
  ColumnTextAlign["Right"] = "right";
})(ColumnTextAlign || (ColumnTextAlign = {}));